function initVerticalText() {
  $('.rotated').each(function(e) {
    var elem = $(this).children().get(0);
    var full = $(elem).outerWidth();
    var half = (full / 2) - 30;
    $(elem).css('top',(half - 10));
    $(elem).css('right',-half);
    $(elem).parent().css('min-height',full);
  });
}
